import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import getEnv from "env";
import { getCurrentYear } from "utils/helpers/getCurrentYear";
import { isHATenant } from "utils/user/organization";
import PrivacyPolicy from "assets/pdf/accumulus_privacy_policy.pdf";
import TermsOfUse from "assets/pdf/accumulus_terms_of_use.pdf";
import styles from "./LegalFooter.styles";

const LegalFooter = () => {
  const { t } = useTranslation("common");

  const isMultitenancyEnabled = getEnv().multitenancyEnabled === "true";

  return (
    <Box sx={styles.container} role="contentinfo">
      <Typography component="span" variant="body2">
        {t("footnoteCreatedBy", { currentYear: getCurrentYear() })}
      </Typography>
      <Box component="span">
        <Link to={PrivacyPolicy} rel="noreferrer" target="_blank">
          <Typography variant="body2">{t("privacyPolicy")}</Typography>
        </Link>
        {isHATenant() && !isMultitenancyEnabled && (
          <Link to={TermsOfUse} rel="noreferrer" target="_blank">
            <Typography variant="body2">{t("termsOfUse")}</Typography>
          </Link>
        )}
      </Box>
    </Box>
  );
};

export default LegalFooter;
